import {Component, computed, OnInit, signal} from "@angular/core";
import {PageNotFoundService} from "../../core/services/services/page-not-found.service";
import {isUndefined} from "lodash";
import {TranslatableComponent} from "../../core/models/TranslatableComponent";
import {TranslateService} from "@ngx-translate/core";
import {Router, RouterLink} from "@angular/router";

export interface PageNotFoundData {
	/**
	 * Http code
	 */
	status: number;
	/**
	 * type as defined in i18n files
	 */
	type?: string;
	/**
	 * URL to link to
	 */
	action?: string;
	data?: string[];
}

@Component({
	selector: "app-page-not-found",
	templateUrl: "./page-not-found.component.html",
	styleUrls: ["./page-not-found.component.scss"],
	standalone: true,
	imports: [RouterLink],
})
export class PageNotFoundComponent extends TranslatableComponent implements OnInit {
	public data = signal<PageNotFoundData>({
		status: 404,
	});

	subHeading = computed(() => {
		return this._lang("status." + this.data().status, {
			entitySingular: this._lang("type." + this.data().type + ".singular"),
			entityPlural: this._lang("type." + this.data().type + ".plural"),
		});
	});

	action = computed(() => {
		if (this.data().action === undefined) {
			return undefined;
		}
		return {
			label: this._lang("action.title", {
				entity: this._lang("action.entities." + this.data().type),
			}),
			url: this.data().action,
		};
	});

	constructor(
		private _translate: TranslateService,
		private _pageNotFoundService: PageNotFoundService,
		private _router: Router,
	) {
		super(_translate, "PageNotFoundComponent");
	}

	ngOnInit(): void {
		if (this._router.url.includes("/error")) {
			this.data.set({
				status: 500,
			});
		}

		if (!isUndefined(this._pageNotFoundService.data)) {
			this.data.set(this._pageNotFoundService.data);
			this._pageNotFoundService.data = undefined;
		}
	}
}
